/* Viva La Vulva — discount code box in the cart page + cart drawer.
 * Inserted above the subtotal inside [data-cart-footer] (snippets/cart-footer.liquid)
 * whenever that footer is on the page, so it also appears in the drawer after
 * the theme re-renders it. Loaded from snippets/js-bridge.liquid.
 */
(function () {
  var css = document.createElement('style');
  css.textContent =
    '.vlv-discount{margin:0 0 .75rem;text-align:left}' +
    '.vlv-discount-form{display:flex;gap:.5rem}' +
    '.vlv-discount-form input{flex:1;min-width:0;padding:.55rem .9rem;border:1px solid #5E444B;border-radius:999px;font-size:.9rem;background:#fff;color:#3F2A30}' +
    '.vlv-discount-form button{padding:.55rem 1.1rem;border-radius:999px;border:1px solid #5E444B;background:transparent;font-size:.9rem;cursor:pointer;color:inherit}' +
    '.vlv-discount-form button:disabled{opacity:.5;cursor:progress}' +
    '.vlv-discount-msg{margin-top:.4rem;font-size:.8rem;color:#EC008C}' +
    '.vlv-discount-applied{list-style:none;margin:0 0 .5rem;padding:0;font-size:.85rem}' +
    '.vlv-discount-applied li{display:flex;justify-content:space-between;gap:.5rem}' +
    '.vlv-discount-applied a{text-decoration:underline;font-size:.8rem}';
  (document.head || document.documentElement).appendChild(css);

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(body) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function refresh() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (window.vlvRefreshCart) { window.vlvRefreshCart(); return; }
    location.reload();
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function remember(code) {
    if (code !== 'BIRTHGIFT') return;
    try { localStorage.setItem('vlvGiftCode', JSON.stringify({ code: code, at: Date.now() })); } catch (e) {}
  }

  var uid = 0;
  function build() {
    var box = document.createElement('div');
    var id = 'vlv-discount-' + (++uid);
    box.className = 'vlv-discount';
    box.innerHTML =
      '<ul class="vlv-discount-applied" data-vlv-applied hidden></ul>' +
      '<form class="vlv-discount-form" data-vlv-discount novalidate>' +
        '<label for="' + id + '" class="sr-only">Discount code</label>' +
        '<input id="' + id + '" type="text" name="vlv_discount" placeholder="Discount code" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
        '<button type="submit">Apply</button>' +
      '</form>' +
      '<p class="vlv-discount-msg" data-vlv-discount-msg role="status" hidden></p>';
    return box;
  }

  function showApplied(cart) {
    // BIRTHGIFT-KIT / BIRTHGIFT-SHIP are added by the site for BIRTHGIFT sign-ups: show them as BIRTHGIFT.
    var seen = {};
    var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) {
      return { code: /^BIRTHGIFT(-|$)/i.test(d.code) ? 'BIRTHGIFT' : d.code };
    }).filter(function (d) { if (seen[d.code]) return false; seen[d.code] = 1; return true; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-vlv-applied]'), function (ul) {
      ul.innerHTML = applied.map(function (d) {
        return '<li><span>' + esc(d.code) + ' applied</span><a href="#" data-vlv-discount-remove="' + esc(d.code) + '">Remove</a></li>';
      }).join('');
      ul.hidden = !applied.length;
    });
  }

  function mount() {
    var added = false;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-footer] dl'), function (dl) {
      var parent = dl.parentElement;
      if (!parent || parent.querySelector(':scope > .vlv-discount')) return;
      parent.insertBefore(build(), dl);
      added = true;
    });
    if (added) getCart().then(showApplied).catch(function () {});
  }

  function msg(form, text) {
    var m = form.parentElement.querySelector('[data-vlv-discount-msg]');
    if (m) { m.textContent = text; m.hidden = !text; }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-vlv-discount]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="vlv_discount"]');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) return;
    var btn = form.querySelector('button');
    btn.disabled = true;
    msg(form, '');
    if (code === 'BIRTHGIFT') {
      // BIRTHGIFT only works with the comb in the cart, so hand it to the free-comb
      // script (assets/vlv-free-comb.js), which adds the comb + code at $65.
      remember(code);
      getCart().then(function (c) {
        var other = 0;
        var kit = (c.items || []).some(function (i) { return i.variant_id === 47677694574889; });
        (c.items || []).forEach(function (i) { if (i.variant_id !== 44969199010089) other += i.original_line_price; });
        msg(form, kit ? 'Yay! Your Birth Comb is coming off your Labour of Love kit.' : other >= 6500
          ? 'Yay! Your free Birth Comb is being added to your cart.'
          : 'Almost there! BIRTHGIFT gives you a free Birth Comb once your cart reaches $65.');
        btn.disabled = false;
        if (window.vlvCombCheck) window.vlvCombCheck();
      });
      return;
    }
    getCart().then(function (c) {
      var codes = (c.discount_codes || []).map(function (d) { return d.code; });
      if (codes.map(function (x) { return x.toUpperCase(); }).indexOf(code) === -1) codes.push(code);
      return post({ discount: codes.join(',') });
    }).then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code; })[0];
      remember(code);
      if (hit && hit.applicable) { refresh(); return; }
      // Shopify keeps a code that can't apply yet; take it back off and explain.
      var keep = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() !== code; }).map(function (d) { return d.code; });
      post({ discount: keep.join(',') });
      msg(form, 'Sorry, that code can’t be used with this cart.');
      btn.disabled = false;
    }).catch(function () {
      msg(form, 'Something went wrong. You can also enter your code at checkout.');
      btn.disabled = false;
    });
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-vlv-discount-remove]');
    if (!rm) return;
    e.preventDefault();
    var code = rm.getAttribute('data-vlv-discount-remove').toUpperCase();
    if (code === 'BIRTHGIFT') { try { localStorage.removeItem('vlvGiftCode'); } catch (err) {} }
    getCart().then(function (c) {
      var keep = (c.discount_codes || []).map(function (d) { return d.code; }).filter(function (x) {
        x = x.toUpperCase();
        return code === 'BIRTHGIFT' ? !/^BIRTHGIFT(-|$)/.test(x) : x !== code;
      });
      if (code === 'BIRTHGIFT') document.cookie = 'discount_code=; path=/; max-age=0';
      return post({ discount: keep.join(',') });
    }).then(refresh);
  });

  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(mount, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
